"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var check_box_1 = __importDefault(require("~/components/forms/common/check_box"));
var mobx_react_1 = require("mobx-react");
var recaptcha_1 = require("~/util/recaptcha");
var FormFooter = (0, mobx_react_1.observer)(function (props) {
    var _a = (0, react_1.useState)(false), isSubmitting = _a[0], setIsSubmitting = _a[1];
    (0, react_1.useEffect)(function () {
        if (props.recaptchaSiteKey) {
            (0, recaptcha_1.loadRecaptchaScript)(props.recaptchaSiteKey).catch(function (error) {
                console.error('failed to preload reCAPTCHA script:', error);
            });
        }
    }, []);
    var handleSubmitReview = function () { return __awaiter(void 0, void 0, void 0, function () {
        var token, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isSubmitting)
                        return [2 /*return*/];
                    setIsSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, 6, 7]);
                    token = null;
                    if (!props.recaptchaSiteKey) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, recaptcha_1.executeRecaptcha)(props.recaptchaSiteKey, 'submit_hikakaku_review')];
                case 2:
                    token = _a.sent();
                    _a.label = 3;
                case 3: return [4 /*yield*/, props.store.submitReview(token)];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 7];
                case 5:
                    error_1 = _a.sent();
                    console.error('submit failed:', error_1);
                    return [3 /*break*/, 7];
                case 6:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "formsCommon-FormFooter_Container" },
        props.askUpdateNickname &&
            react_1.default.createElement(check_box_1.default, { label: "\u30CB\u30C3\u30AF\u30CD\u30FC\u30E0\u3092\u767B\u9332\u60C5\u5831\u306B\u53CD\u6620\u3059\u308B", checked: props.store.updateNickname, onChange: function (checked) { props.store.updateNickname = checked; } }),
        react_1.default.createElement("button", { className: "formsCommon-FormFooter_SubmitButton", onClick: handleSubmitReview, disabled: isSubmitting }, isSubmitting ? '投稿中...' : 'クチコミを投稿する'),
        react_1.default.createElement("div", { className: "formsCommon-FormFooter_Attention" },
            "\u6295\u7A3F\u3068\u540C\u6642\u306B",
            react_1.default.createElement("a", { href: "/review-term/", target: "_blank", rel: "noopener noreferrer nofollow" }, "\u30AF\u30C1\u30B3\u30DF\u5229\u7528\u898F\u7D04"),
            "\u306B\u540C\u610F\u3057\u305F\u3068\u307F\u306A\u3055\u308C\u307E\u3059")));
});
exports.default = FormFooter;
